import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { SpecificUse, specificUseType } from '../../types/slices/specificUseType'

const initialState: specificUseType =
{
    status: ApiStatus.FETCHED,
    specificUses: [],
    specificUseSelected: {} as SpecificUse,
    errorMessage: undefined,
    action: ''
}

const specificUsesSlice = createSlice({
    name: 'specificUsesSlice',
    initialState,
    reducers: {
        onFetchSpecificUses (state, { payload }: { payload: SpecificUse[]}) {
            state.status = ApiStatus.FETCHED
            state.specificUses = payload
            state.errorMessage = undefined
        },
        onSetSelectedSpecificUse (state, { payload }: { payload: SpecificUse }) {
            state.specificUseSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSpecificUseState = (state: RootState) => state.specificUsesSlice
export default specificUsesSlice.reducer
export const {
    onFetchSpecificUses,
    onSetSelectedSpecificUse,
    changeStatus,
    setAction,
} = specificUsesSlice.actions
